import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";

export default function useShopDomains(shopId: string) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/preferences/notifications/domains",
    {
      params: { path: { shopId } },
    },
  );
}

export function useInvalidateShopDomains(shopId: string) {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: [
        "get",
        "/shops/{shopId}/preferences/notifications/domains",
        { params: { path: { shopId } } },
      ],
    });
  };
}
